import moment from 'moment';
import { Transaction } from '../interfaces/transaction';
import { TFunction } from 'i18next';

export const groupAndSortTransactions = (data: Transaction[]) => {
  const groupedTransactions: Record<string, Transaction[]> = {};
  if (!data) return groupedTransactions;
  data.forEach(transaction => {
    if (!groupedTransactions[formatDate(transaction.accountingDate)]) {
      groupedTransactions[formatDate(transaction.accountingDate)] = [];
    }

    groupedTransactions[formatDate(transaction.accountingDate)].push(transaction);
  });

  return groupedTransactions;
};

export const createTransactionDate = (isoDate: string, t: TFunction<'translation', undefined>) => {
  const date = moment(isoDate);
  const today = moment();
  const yesterday = moment().subtract(1, 'day');

  if (today.isSame(date, 'day')) return moment(date).format('HH:mm');
  if (yesterday.isSame(date, 'day')) return `${t('transactionPage.yesterday')}, ${moment(date).format('HH:mm')}`;
  return moment(date).format('DD/MM/YYYY, HH:mm');
};

const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  const today = new Date();
  if (today === date) return 'Today';

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const formattedMonth = monthNames[date.getMonth()];

  return new Intl.DateTimeFormat('en-US', options).format(date).replace(/^(\w+), (\w+) (\d+), (\d+)$/, `$1, $3 ${formattedMonth} $4`);
};
